import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { subscribeNewsletter } from '../../api/newsletter';
import styles from './Footer.module.css';

// Refresh these from Figma within 7 days — then upload to Cloudinary
const LOGO_WHITE = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1773094526/2d84a764693362c80d1e3dc38f7b339504b19d2e_iobboq.png';
const FOOTER_BG  = 'https://res.cloudinary.com/dhjzovpof/image/upload/v1775288556/2d84a764693362c80d1e3dc38f7b339504b19d2e_1_ip7cx2.png';

const NAV_LINKS = [
  { label: 'About',          to: '/about'    },
  { label: 'Teams',          to: '/team'     },
  { label: 'Tektron Group',          to: '/group'     },

  { label: 'Services', to: '/services'   },
  { label: 'Portfolio',      to: '/impact'   },
  { label: 'Tektron Thermo',      to: '/thermo'   },
  { label: 'Projects',       to: '/projects' },
  { label: 'Partners',       to: '/partners' },
  { label: 'Contact',        to: '/contact'  },
];

const SOCIAL_LINKS = [
  { label: 'Facebook',    href: 'https://facebook.com/tektronplus'         },
  { label: 'X (Twitter)', href: 'https://twitter.com/tektronplus'          },
  { label: 'Instagram',   href: 'https://instagram.com/tektronplus'        },
  { label: 'LinkedIn',    href: 'https://linkedin.com/company/tektronplus' },
];

export default function Footer() {
  const [email, setEmail]       = useState('');
  const [status, setStatus]     = useState('idle'); // 'idle' | 'loading' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  const isLoading = status === 'loading';

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    setErrorMsg('');
    try {
      await subscribeNewsletter(email);
      setStatus('success');
      setEmail('');
    } catch (err) {
      console.error('Newsletter error:', err);
      setStatus('error');
      setErrorMsg('Could not subscribe. Please try again.');
    }
  };

  return (
    <footer className={styles.footer}>

      {/* Background watermark — large rotated logo, centered */}
      <div className={styles.bgWatermark} aria-hidden="true">
        <img src={FOOTER_BG} alt="" />
      </div>

      {/* ── Top row: logo+newsletter | nav+social ── */}
      <div className={styles.top}>

        {/* Left: logo above newsletter */}
        <div className={styles.left}>
          <Link to="/">
            <img src={LOGO_WHITE} alt="TektronPlus" className={styles.logo} />
          </Link>

          <div className={styles.newsletter}>
            <p className={styles.newsletterLabel}>Join our newsletter</p>

            {/* Subscribe section: input row + disclaimer */}
            <div className={styles.subscribeWrapper}>
              {status === 'success' ? (
                <div className={styles.successRow}>
                  <span className={styles.successCheck}>✓</span>
                  <span className={styles.successText}>You're subscribed!</span>
                </div>
              ) : (
                <form className={styles.inputRow} onSubmit={handleSubscribe}>
                  <input
                    type="email"
                    placeholder="Enter Email Address"
                    className={`${styles.input} ${isLoading ? styles.inputBusy : ''}`}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    disabled={isLoading}
                    required
                  />
                  <button
                    type="submit"
                    className={`${styles.subscribeBtn} ${isLoading ? styles.subscribeBtnLoading : ''}`}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <span className={styles.spinner} aria-hidden="true" />
                    ) : (
                      'Subscribe'
                    )}
                  </button>
                </form>
              )}

              {status === 'error' && (
                <p className={styles.errorText}>{errorMsg}</p>
              )}

              {status !== 'error' && (
                <p className={styles.disclaimer}>By clicking, you're agreeing to our Terms.</p>
              )}
            </div>
          </div>
        </div>

        {/* Right: nav col (6 links, 302px) + social col (4 links, 204px) */}
        <div className={styles.links}>
          <div className={styles.col}>
            {NAV_LINKS.map(({ label, to }) => (
              <Link key={label} to={`${to}`} className={styles.link}
                    onClick={() => window.scrollTo(0, 0)}
              >{label}</Link>
            ))}
          </div>
          <div className={styles.col}>
            {SOCIAL_LINKS.map(({ label, href }) => (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" className={styles.link}>
                {label}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* ── Bottom: divider + copyright row — gap-24px ── */}
      <div className={styles.footerBottom}>
        <hr className={styles.divider} />
        <div className={styles.bottom}>
          <p className={styles.copy}>
            © 2015{' '}
            <span className={styles.copyBrand}>Tektron</span><span className={styles.copyPlus}>plus</span>
          </p>
          <div className={styles.legal}>
            <a href="/" className={styles.legalLink}>Terms</a>
            <span className={styles.dot} />
            <a href="/" className={styles.legalLink}>Privacy</a>
          </div>
        </div>
      </div>

    </footer>
  );
}
